const CatalogServicesComponent = {
    data() {
        return {
            services: [],
            loading: false,
            swiper: null,
        };
    },

    methods: {
        async getServices() {
            this.loading = true;

            try {
                const response = await window.serviceService.getServices({ limit: 12 });
                this.services = response.data ?? [];

                this.$nextTick(() => {
                    if (this.swiper) {
                        this.swiper.update();
                    }
                });

            } finally {
                this.loading = false;
            }
        },

        initSwiper() {
            const root = this.$el;
            const slider = root.querySelector('.servicesSlider');
            const nextEl = root.querySelector('.slider__top-next');
            const prevEl = root.querySelector('.slider__top-prev');

            this.swiper = new Swiper(slider, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                navigation: { nextEl, prevEl },
                breakpoints: {
                    576: { slidesPerView: 2, spaceBetween: 16 },
                    768: { slidesPerView: 3, spaceBetween: 20 },
                    1024: { slidesPerView: 4, spaceBetween: 24 },
                },
            });
        },
    },

    mounted() {
        this.initSwiper();
        this.getServices();
    },
};

window.CatalogServicesComponent = CatalogServicesComponent;